export default __webpack_public_path__ + "static/media/EmptyNote.8af31ed8.svg";